import { asMenuItem, MenuItem } from "../../components/menu";
import "./activity.css";

const ICON = { ios: "f7:clock_fill", md: "material:history" };

const ActivityButton = asMenuItem(({ onClick }) => (
  <MenuItem
    className="activity-entry"
    title="Änderungsverlauf"
    icon={ICON}
    tone="gray"
    onClick={onClick}
  />
));

export default ActivityButton;
